/* eslint-disable no-undef */
import React from "react";

function ViewDoc(props) {
  return (
    <div style={{ display: props.display === true ? "flex" : "none" }}>
      <img src={require("../../../../assets/ViewDoc.png")} />
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        width="72"
        height="32"
        viewBox="0 0 72 32"
        fill="none"
        style={{ position: "absolute", right: "20px", bottom: "-2.5px" }}
      >
        <g filter="url(#filter0_d_6972_232771)">
          <mask id="path-1-inside-1_6972_232771" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14 6C11.7909 6 10 7.79086 10 10V24C10 26.2091 11.7909 28 14 28H64C66.2091 28 68 26.2091 68 24V21.726L71.7923 17.9337C72.1828 17.5431 72.1828 16.91 71.7923 16.5194L68 12.7271V10C68 7.79086 66.2091 6 64 6H14Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 6C11.7909 6 10 7.79086 10 10V24C10 26.2091 11.7909 28 14 28H64C66.2091 28 68 26.2091 68 24V21.726L71.7923 17.9337C72.1828 17.5431 72.1828 16.91 71.7923 16.5194L68 12.7271V10C68 7.79086 66.2091 6 64 6H14Z"
            fill="#E8ECF4"
          />
          <path
            d="M68 21.726L67.2929 21.0189L67 21.3118V21.726H68ZM71.7923 17.9337L72.4994 18.6408V18.6408L71.7923 17.9337ZM71.7923 16.5194L71.0852 17.2266L71.0852 17.2266L71.7923 16.5194ZM68 12.7271H67V13.1414L67.2929 13.4343L68 12.7271ZM11 10C11 8.34315 12.3431 7 14 7V5C11.2386 5 9 7.23858 9 10H11ZM11 24V10H9V24H11ZM14 27C12.3431 27 11 25.6569 11 24H9C9 26.7614 11.2386 29 14 29V27ZM64 27H14V29H64V27ZM67 24C67 25.6569 65.6569 27 64 27V29C66.7614 29 69 26.7614 69 24H67ZM67 21.726V24H69V21.726H67ZM71.0852 17.2266L67.2929 21.0189L68.7071 22.4331L72.4994 18.6408L71.0852 17.2266ZM71.0852 17.2266L72.4994 18.6408C73.2805 17.8597 73.2805 16.5934 72.4994 15.8123L71.0852 17.2266ZM67.2929 13.4343L71.0852 17.2266L72.4994 15.8123L68.7071 12.02L67.2929 13.4343ZM67 10V12.7271H69V10H67ZM64 7C65.6569 7 67 8.34315 67 10H69C69 7.23858 66.7614 5 64 5V7ZM14 7H64V5H14V7Z"
            fill="#18468F"
            mask="url(#path-1-inside-1_6972_232771)"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_6972_232771"
            x="0"
            y="0"
            width="82.085"
            height="42"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6972_232771" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6972_232771" result="shape" />
          </filter>
        </defs>
        <text
          x="55%"
          y="63%"
          text-anchor="middle"
          fill="var(--primary-Blue, #18468F)"
          font-family="Poppins"
          font-size="11px"
          font-style="normal"
          font-weight="400"
          line-height="16px"
        >
          View Doc
        </text>
      </svg> */}
    </div>
  );
}

export default ViewDoc;
